/** Organisation letterhead + HTML→PDF — `salescrmapi/src/modules/letterhead`. */
import apiClient from './axiosClient.js';

export async function getLetterhead() {
  return (await apiClient.get('/letterhead')).data;
}
export async function saveLetterhead({ html, file_name }) {
  return (await apiClient.put('/letterhead', { html, file_name })).data;
}
export async function removeLetterhead() {
  await apiClient.delete('/letterhead');
}

/** Fetch a PDF (auth header needed, so not a plain link) and hand it to the browser as a download. */
export async function downloadPdf(path, fileName, options = {}) {
  const res = await (options.body
    ? apiClient.post(path, options.body, { responseType: 'blob' })
    : apiClient.get(path, { responseType: 'blob' }));
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url; a.download = fileName; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
